import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Celsius = {
    id: "celsius",
    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    ticks: {
        fontSize: tickFontSize,
        maxTicksLimit: 10,

        callback: (value, index, values) => {
            return "  " + Units.rounded(value,2) + "°";
        }
    }
};

export default Celsius;


// WEBPACK FOOTER //
// ./src/components/chart/axes/Celsius.js